import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsUngatedForPersonalizationVariants } from '../redux/selectors/authSelectors';
import { getHasPersonalizedVariants, getIsPersonalizedVariant } from '../redux/selectors/pageContentModelSelectors';
import { useFetchPersonalizationVariants } from './useFetchPersonalizationVariants';
import { VariantStatuses } from '../constants/PersonalizationVariants';
export const usePersonalizedPageUrl = ({
  contentId
}) => {
  const isPersonalizedVariant = useSelector(getIsPersonalizedVariant);
  const isPersonalizationDefault = useSelector(getHasPersonalizedVariants);
  const isUngatedForPersonalizationVariants = useSelector(getIsUngatedForPersonalizationVariants);
  const {
    data
  } = useFetchPersonalizationVariants({
    contentId,
    shouldFetch: isUngatedForPersonalizationVariants && (isPersonalizedVariant || isPersonalizationDefault)
  });
  return useMemo(() => {
    const allVariants = (data === null || data === void 0 ? void 0 : data.personalizationVariants) || [];
    const personalizationDefault = allVariants.find(({
      personalizationVariantStatus
    }) => personalizationVariantStatus === VariantStatuses.DEFAULT);
    return personalizationDefault === null || personalizationDefault === void 0 ? void 0 : personalizationDefault.publishedUrl;
  }, [data === null || data === void 0 ? void 0 : data.personalizationVariants]);
};